module.exports = __webpack_public_path__ + "media/images/avatar-1e8ee60a.png";